import { Component, OnInit } from '@angular/core';
import { ApplicationListItem, ApplicationsService } from '../../services/applications.service';

@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss']
})
export class ApplicationsComponent implements OnInit {
  applications: ApplicationListItem[] = [];
  private allApplications: ApplicationListItem[] = [];
  loading = false;
  error: string | null = null;

  searchTerms = '';
  searching = false;
  searchError: string | null = null;
  hasActiveSearch = false;

  constructor(private applicationsService: ApplicationsService) { }

  ngOnInit(): void {
    this.loadApplications();
  }

  private loadApplications(): void {
    this.loading = true;
    this.error = null;
    this.searchError = null;

    this.applicationsService.list().subscribe({
      next: (apps) => {
        const list = Array.isArray(apps) ? apps : [];
        this.allApplications = list;
        this.applications = list;
        this.loading = false;
      },
      error: () => {
        this.error = 'Failed to load applications.';
        this.loading = false;
      }
    });
  }

  search(): void {
    const terms = this.searchTerms.trim();
    this.searchError = null;

    if (terms.length === 0) {
      this.clearSearch();
      return;
    }

    this.searching = true;
    this.applicationsService.search(terms).subscribe({
      next: (apps) => {
        this.applications = Array.isArray(apps) ? apps : [];
        this.hasActiveSearch = true;
        this.searching = false;
      },
      error: () => {
        this.searchError = 'Search failed.';
        this.searching = false;
      }
    });
  }

  clearSearch(): void {
    this.searchTerms = '';
    this.searchError = null;
    this.hasActiveSearch = false;
    this.loadApplications();
  }

  trackByIndex(index: number): number {
    return index;
  }

  getApplicationId(app: ApplicationListItem): number | null {
    const raw = (app as Record<string, unknown>)['id'];
    if (typeof raw === 'number' && Number.isFinite(raw)) {
      return raw;
    }
    if (typeof raw === 'string' && raw.trim() !== '') {
      const n = Number(raw);
      return Number.isFinite(n) ? n : null;
    }
    return null;
  }

  getApplicationName(app: ApplicationListItem): string {
    const anyApp = app as Record<string, unknown>;
    const candidate =
      anyApp['applicationName'] ??
      anyApp['name'] ??
      anyApp['title'];
    return typeof candidate === 'string' && candidate.trim() !== ''
      ? candidate
      : this.displayApplication(app);
  }

  getApplicationIsActive(app: ApplicationListItem): boolean | null {
    const raw =
      (app as Record<string, unknown>)['isActive'] ??
      (app as Record<string, unknown>)['IsActive'];
    if (typeof raw === 'boolean') {
      return raw;
    }
    if (typeof raw === 'string') {
      const v = raw.toLowerCase();
      if (v === 'true' || v === '1') return true;
      if (v === 'false' || v === '0') return false;
    }
    if (typeof raw === 'number') {
      return raw !== 0;
    }
    return null;
  }

  getApplicationContactName(app: ApplicationListItem): string {
    const raw =
      (app as Record<string, unknown>)['contactName'] ??
      (app as Record<string, unknown>)['ContactName'];
    return typeof raw === 'string' ? raw : raw != null ? String(raw) : '';
  }

  getApplicationContactEmail(app: ApplicationListItem): string {
    const raw =
      (app as Record<string, unknown>)['contactEmail'] ??
      (app as Record<string, unknown>)['ContactEmail'];
    return typeof raw === 'string' ? raw : raw != null ? String(raw) : '';
  }

  displayApplication(app: ApplicationListItem): string {
    const anyApp = app as Record<string, unknown>;
    const candidate =
      anyApp['name'] ??
      anyApp['applicationName'] ??
      anyApp['title'] ??
      anyApp['id'];
    return typeof candidate === 'string' || typeof candidate === 'number'
      ? String(candidate)
      : JSON.stringify(app);
  }
}
